// import './App.css';
import { useEffect, useState } from "react";
import {
  FormControl,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Container,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import ReactFlagsSelect from "react-flags-select";
import { updateAssessmentSection, createAssessmentSection } from "../services/api";

const classes = {};

function AssessmentSectionForm({ assessmentSection, assessmentId, onSaveSuccess }) {
  const [languagePartForm, setLanguagePartForm] = useState({ EN: { title: "", description: "" } });
  const [language, setLanguage] = useState("EN");
  const [languageForSelect, setLanguageForSelect] = useState("GB");

  const [isFirst, setIsFirst] = useState(false);
  const [nickname, setNickname] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (assessmentSection.assessmentSectionTRs?.length) {
      let obj = {};
      assessmentSection.assessmentSectionTRs.forEach((tr) => {
        obj[tr.language] = {
          title: tr.section_title || "",
          description: tr.section_description || "",
          id: tr.id || undefined
        };
      });
      if (!obj["EN"]) {
        setLanguage(obj[assessmentSection.assessmentSectionTRs[0].language]);
      }
      setLanguagePartForm(obj);
    }
  }, [assessmentSection]);

  const refreshForm = () => {
    if (assessmentSection.id) {
      setIsFirst(assessmentSection.is_first);
      setNickname(assessmentSection.nickname);
    } else {
      setIsFirst(false);
      setNickname("");
    }
  };

  const saveChanges = () => {
    setLoading(true);
    assessmentSection.is_first = isFirst;
    assessmentSection.assessmentSectionTRs = [];
    assessmentSection.nickname = nickname;
    Object.keys(languagePartForm).forEach((key) => {
      assessmentSection.assessmentSectionTRs.push({
        language: key,
        section_title: languagePartForm[key].title,
        section_description: languagePartForm[key].description,
        id: languagePartForm[key].id || undefined
      });
    });
    if (assessmentSection.id) {
      updateAssessmentSection(assessmentSection)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      assessmentSection.assessment_id = assessmentId;
      createAssessmentSection(assessmentSection)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    refreshForm();
  }, []);

  const handleFieldChange = (setFunction) => {
    return (event) => {
      setFunction(event.target.value);
    };
  };

  const onChangeTitle = (value) => {
    setLanguagePartForm((oldForm) => {
      let form = { ...oldForm };
      form[language].title = value;
      return form;
    });
  };
  const onChangeDescription = (value) => {
    setLanguagePartForm((oldForm) => {
      let form = { ...oldForm };
      form[language].description = value;
      return form;
    });
  };

  const onChangeLanguage = (value) => {
    /* TO CHANGE FROM GB TO EN (country to language) */
    let newValue;
    if (value === "GB") {
      newValue = "EN";
    } else {
      newValue = value;
    }

    setLanguage(newValue);
    setLanguageForSelect(value);
    if (!languagePartForm[newValue]) {
      setLanguagePartForm((oldForm) => {
        let form = { ...oldForm };
        form[newValue] = {
          title: "",
          description: "",
        };
        return form;
      });
    }
  };

  return (
    <LoadingOverlay active={loading} spinner>
      <div class="bodyModal">
        <FormControl className="inputForms flagSelect">
          <InputLabel id="languageLabelAssessmentSection">Language</InputLabel>
          <ReactFlagsSelect
            labelId="languageLabelAssessmentSection"
            id="languageAssessmentSection"
            selected={languageForSelect}
            onSelect={(code) => onChangeLanguage(code)}
            countries={["ES", "GB"]}
            customLabels={{ GB: "English", ES: "Spanish" }}
            searchable
          />
        </FormControl>
        <FormControl>
          <TextField
            label="Title"
            value={languagePartForm[language].title}
            onChange={handleFieldChange(onChangeTitle)}
            className="inputForms"
          />
          <TextField
            label="Description"
            value={languagePartForm[language].description}
            onChange={handleFieldChange(onChangeDescription)}
            className="inputForms"
          />

          <TextField
            label="Name"
            value={nickname}
            onChange={handleFieldChange(setNickname)}
            className="inputForms"
          />

          <FormControlLabel
            control={
              <Switch
                checked={isFirst}
                onChange={(evt) => {
                  setIsFirst(evt.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Is First"
          />
        </FormControl>
        <div className="text-center">
          <Button variant="contained" color="primary" onClick={saveChanges} className="btn-main-limber mb-15 mt-15">
            Save
          </Button>
        </div>
      </div>
    </LoadingOverlay>
  );
}

export default AssessmentSectionForm;
